/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Payment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Notes/FilterBy/EntityType/Payment"
  
}) {
let tabSelectedLedgerNotesFilterByValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.notes.filter_by',
})
let constantData = 'payment'
let aggregateData = fromAggregate.includes(tabSelectedLedgerNotesFilterByValueData, constantData)
let onClick = fromHelpers.useOnFilterClickPayment({
  children,
  viewPath
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let notesValueData = fromData.useDataValue({ viewPath,
context: 'notes',
})
let constantData1 = 'payment'
let aggregateData1 = fromHelpers.getCount(notesValueData, constantData1)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 type={aggregateData ? "primary" : "secondary"}
 data="tab.selected.ledger.notes.filter_by"
 data="'payment'"
 aggregate="/Data/aggregate.js includes"
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Payments"
/>
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 alignSelf="center"
 type="grey"
 style="filled"
 size="small"
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="notes"
 data="'payment'"
 aggregate="helpers.js getCount"
 text={aggregateData1}
/>
)}
</TysiaTag>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}